export const COOKIE_KEYS = {
  CookieConsent: "cookie_consent",
  HideCookieConsent: "hide_consent",
  AuthToken: "token",
} as const;
